import { createContext, type ReactNode, useContext, useMemo } from 'react';

import { getAccessToken } from '../auth/driver-auth';
import { DriverErpService } from './driver-erp';

const DriverErpContext = createContext<DriverErpService | null>(null);

/**
 * Provides a single {@link DriverErpService} bound to the PKCE token store so
 * the My Pickups / Pickup detail screen containers (Tasks 11-12) can resolve it
 * via {@link useDriverErp}.
 */
export function DriverErpProvider({ children }: { children: ReactNode }) {
  const service = useMemo(() => new DriverErpService(getAccessToken), []);
  return (
    <DriverErpContext.Provider value={service}>
      {children}
    </DriverErpContext.Provider>
  );
}

export function useDriverErp(): DriverErpService {
  const service = useContext(DriverErpContext);
  if (!service) {
    throw new Error('useDriverErp must be used within a DriverErpProvider');
  }
  return service;
}
